module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userSet"
    }
  }, [(_vm.showEdit) ? _c('userSetModal', {
    attrs: {
      "uName": _vm.store.account.name,
      "uGender": _vm.userSet.gender,
      "uPlace": _vm.userSet.permanentPlace,
      "uPart": _vm.department,
      "uLabel": _vm.label
    },
    on: {
      "submitData": _vm.saveUser,
      "close": _vm.cancelModal
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "partStyle"
  }, [_c('ul', [_c('li', {
    staticClass: "evenStyle",
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("头像")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [(_vm.showIMG) ? _c('uploadImg', {
    attrs: {
      "path": _vm.imgPath
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.store.account.name))])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("性别")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.sex))])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("医院科室")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.department))])]), _vm._v(" "), (_vm.label) ? _c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("岗位")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("常住地")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.userSet.permanentPlace))])]), _vm._v(" "), _c('div', {
    staticClass: "changeStyle pointer",
    on: {
      "click": _vm.editUser
    }
  }, [_vm._v("信息有误，修改信息")])]), _vm._v(" "), _c('div', {
    staticClass: "partStyle"
  }, [(_vm.showMobile) ? _c('mobileChange', {
    attrs: {
      "mobile": _vm.userSet.mobile
    },
    on: {
      "close": _vm.cancelMobile,
      "submitData": _vm.submitCase
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.showAlert,
      "title": "手机绑定成功"
    }
  }, [_c('span', [_vm._v("您当前的手机号为" + _vm._s(_vm.newPhone) + "，下次登录请使用此手机号。")]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "evenStyle",
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("电话/账号绑定")]), _vm._v(" "), _c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("绑定电话")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.userMobile) + "   "), _c('span', {
    staticClass: "changeStyle pointer",
    staticStyle: {
      "color": "#0a81e5",
      "width": "30px"
    },
    on: {
      "click": _vm.changeMobile
    }
  }, [_vm._v("更换号码")])])]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("登录密码")]), _vm._v(" "), _c('passChange', {
    attrs: {
      "username": _vm.store.account.username
    }
  })], 1), _vm._v(" "), _c('ul')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e873646!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/doc/userSet.vue
// module id = 961
// module chunks = 2